import { useWindowSize } from '@vueuse/core';
import isMobileUA from 'is-mobile';
import { ref, watch } from 'vue';

const MOBILE_BRAKEPOINT = 639;

export const useMobileDetection = (useUseragent: boolean = false) => {
  const isMobile = ref(isMobileUA());

  if (useUseragent) {
    return { isMobile };
  }

  const { width } = useWindowSize();
  const checkIsMobile = (width: number) => {
    if (width > MOBILE_BRAKEPOINT) {
      isMobile.value = false;
      return;
    }

    isMobile.value = true;
  };

  watch(width, checkIsMobile);
  checkIsMobile(width.value);

  return { isMobile };
};
